import * as React from 'react';
import Helmet from 'react-helmet';
import { IStore } from '../../redux/IStore';
import axios from 'axios';
import { Store } from 'redux';
import { IChannel } from '../../data/api/models';

interface IHtmlProps {
  markup?: string;
  store?: Store<IStore>;
  jobsState?: any;
  channel: IChannel;
  isOffline: boolean;
}

class Html extends React.Component<IHtmlProps, {}> {
  public render() {
    const head = Helmet.rewind();
    const { markup, store, jobsState, channel, isOffline } = this.props;
    const styles = [];
    const scripts = ['/public/js/app.js'];
    const noIndex = process.env.APP_ENV !== 'production';

    let stylesheet = 'salt';

    if (channel.key.indexOf('groupsure') > -1) {
      stylesheet = 'groupsure';
    }

    if (channel.key === 'procycle-b2c') {
      stylesheet = 'procycle';
    }

    if (process.env.NODE_ENV === 'production') {
      styles.push(`/public/css/${stylesheet}.css`);

      // styles.push('/public/css/app.css');
      scripts.unshift('/public/js/vendor.js');
    }

    if (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
      scripts.unshift('/public/vendor.js');
    }

    const renderStyles = styles.map((src, i) =>
      <link key={i} rel="stylesheet" type="text/css" href={src} />,
    );

    const renderScripts = scripts.map((src, i) =>
      <script src={src} key={i} />,
    );

    const globalVars = `
      window.__INITIAL_STATE__ = ${JSON.stringify(store.getState())};
      window.__API_URL__ = '${axios.defaults.baseURL}';
      window.__JOBS_STATE_ = '${JSON.stringify(jobsState)}';
    `;

    // tslint:disable-next-line:max-line-length
    const initialState = (<script dangerouslySetInnerHTML={{ __html: globalVars }} charSet="UTF-8"/>);

    return (
      <html>
      <head>
        {head.base.toComponent()}
        {head.title.toComponent()}
        {head.meta.toComponent()}
        {head.link.toComponent()}
        {noIndex && (<meta name="robots" content="noindex,noimageindex,nofollow,nosnippet" />)}
        {isOffline && head.script.toComponent()}

        {renderStyles}
        {/*<link rel="shortcut icon" href="/favicon.ico" />*/}
      </head>
      <body>
      <main id="app" dangerouslySetInnerHTML={{ __html: markup }} />
      {initialState}
      {renderScripts}
      </body>
      </html>
    );
  }
}

export default Html;
